import type { PrefetchContext, PrefetchedDataProps } from '#src/shared/prefetch';

import { useLocale } from '#src/app/shared/hooks/l10n';

import { prefetchNewsAndGuidesDetailsPageDataFromApi, useNewsAndGuidesDetailsPageDataFromApi } from './pageData';

export type NewsAndGuidesDetailsPagePrefetchedContext = Readonly<{
	pageData: NonNullable<Parameters<typeof useNewsAndGuidesDetailsPageDataFromApi>[0]>;
}>;

export type NewsAndGuidesDetailsPageCombinedState = ReturnType<typeof useNewsAndGuidesDetailsPageDataFromApi>;

export function usePageContext(
	countryCode: string,
	slug: string,
	prefetchedData?: NewsAndGuidesDetailsPagePrefetchedContext,
): NewsAndGuidesDetailsPageCombinedState {
	const locale = useLocale();

	return useNewsAndGuidesDetailsPageDataFromApi(prefetchedData?.pageData, { countryCode, locale, slug });
}

export async function prefetchPageContext(
	countryCode: string,
	slug: string,
	context: PrefetchContext,
): Promise<NewsAndGuidesDetailsPagePrefetchedContext> {
	const { locale } = context.l10n;

	return { pageData: await prefetchNewsAndGuidesDetailsPageDataFromApi(context, { countryCode, locale, slug }) };
}

export type NewsAndGuidesDetailsPagePrefetchedDataProps =
	PrefetchedDataProps<NewsAndGuidesDetailsPagePrefetchedContext>;
